import AboutAwardsArtistPage from '@/molecules/Fragments/Pages/Artist/AboutAwards/AboutAwardsArtistPage';
import AboutBioArtistPage from '@/molecules/Fragments/Pages/Artist/AboutBio/AboutBioArtistPage';
import AboutEducationArtistPage from '@/molecules/Fragments/Pages/Artist/AboutEducation/AboutEducationArtistPage';
import AboutEventsArtistPage from '@/molecules/Fragments/Pages/Artist/AboutEvents/AboutEventsArtistPage';
import AboutLinksArtistPage from '@/molecules/Fragments/Pages/Artist/AboutLinks/AboutLinksArtistPage';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';
import {StyledTitleProps} from './typings';
import colors from '@/theme/constants/colors';
import Image from 'next/image';
import elevation from '@/theme/elevation';
import StyledAccordion from '@/molecules/Accordion/styles';

export const StyledBio = styled(AboutBioArtistPage)`
  grid-area: bio;
  border-bottom: 1px solid ${colors.grey50};

  @media only screen and ${breakpoints.device.m} {
    border-bottom: none;
  }
`;

export const StyledLinks = styled(AboutLinksArtistPage)``;

export const StyledEducation = styled(AboutEducationArtistPage)``;

export const StyledAwards = styled(AboutAwardsArtistPage)``;

export const StyledEvents = styled(AboutEventsArtistPage)``;

export const StyledAboutArtistTitle = styled.h2<StyledTitleProps>`
  ${typography.Section}
  padding: ${sizePx(8)} 0;
  text-align: center;
  background: ${(props) => props.$background ?? colors.green100};
  width: 100%;

  @media only screen and ${breakpoints.device.l} {
    padding: ${sizePx(32)} 0;
  }
`;

export const StyledArtistAboutSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  scroll-margin-top: 117px;

  @media only screen and ${breakpoints.device.s} {
    scroll-margin-top: 191px;
  }

  @media only screen and ${breakpoints.device.m} {
    scroll-margin-top: 148px;
  }

  @media only screen and ${breakpoints.device.l} {
    scroll-margin-top: 191px;
  }
`;

export const StyledGridLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: 'bio' 'side-menu' 'map';

  @media only screen and ${breakpoints.device.m} {
    grid-template-columns: ${sizePx(106)} 1fr;
    grid-template-rows: auto 1fr;
    align-items: start;
    column-gap: 5%;
    row-gap: ${sizePx(20)};
    grid-template-areas: 'side-menu bio' 'side-menu map';
  }
`;

export const StyledSideMenu = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: side-menu;

  & > ${StyledAccordion}:not(:last-of-type) {
    border-bottom: 1px solid ${colors.grey50};
  }

  & > ${StyledAccordion}:last-of-type {
    margin-bottom: ${sizePx(10)};
  }

  @media only screen and ${breakpoints.device.m} {
    & > div:not(:last-of-type) {
      padding-bottom: ${sizePx(10)};
      margin-bottom: ${sizePx(10)};
      border-bottom: 1px solid ${colors.grey50};
    }
  }
`;

export const StyledMap = styled(Image)`
  grid-area: map;
  background-color: ${colors.grey};
  border-radius: ${sizePx(2)};
  width: 100%;
  height: auto;
  aspect-ratio: 740 / 347;
  ${elevation.Default}
`;
